import { menuGroup, menuItem } from "modules/helpers";

// components
import AuthenticatedApp from "./AuthenticatedApp.doc";
import ClaimCheck from "./ClaimCheck.doc";

const components = [
  menuItem("<AuthenticatedApp/>", "authenticated-app", AuthenticatedApp),
  menuItem("<ClaimCheck/>", "claim-check", ClaimCheck),
]

// hooks
import UseAuthClaims from "./UseAuthClaims.doc";
import UseAuthState from "./UseAuthState.doc";
import UseLoggedIn from "./UseLoggedIn.doc";

const hooks = [
  menuItem("useAuthClaims", "use-auth-claims", UseAuthClaims),
  menuItem("useAuthState", "use-auth-state", UseAuthState),
  menuItem("useLoggedIn", "use-logged-in", UseLoggedIn),
]

// selectors
import GetAuthClaim from "./GetAuthClaim.doc";
import GetAuthClaims from "./GetAuthClaims.doc";
import GetAuthState from "./GetAuthState.doc";

const selectors = [
  menuItem("getAuthClaim", "get-auth-claim", GetAuthClaim),
  menuItem("getAuthClaims", "get-auth-claims", GetAuthClaims),
  menuItem("getAuthState", "get-auth-state", GetAuthState),
]

// configuration
import EnableJwtAuth from "./EnableJwtAuth.doc";
import EnableCustomAuth from "./EnableCustomAuth.doc";

const configuration = [
  menuItem("enableJwtAuth", "enable-jwt-auth", EnableJwtAuth),
  menuItem("enableCustomAuth", "enable-custom-auth", EnableCustomAuth),
]

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
  menuGroup("Selectors", "selectors", selectors),
  menuGroup("Configuration", "configuration", configuration),
];
